<div class="row text-center pt-5">
  <div class="col-12 mt-md-0 pt-md-0 pt-5 mt-5"><h3>{{'errors.404' | translate}}</h3></div>
</div>
